module.exports = __webpack_public_path__ + "media/images/costumes/top/logo/logo-1-7d78847d07c36e364e7cc9c7358bea82.png";